import { render, staticRenderFns } from "./EdsCreate.vue?vue&type=template&id=5891f183&"
import script from "./EdsCreate.vue?vue&type=script&lang=js&"
export * from "./EdsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports